import { getSiteConfigByHostname } from '@alexis/helpers/site';

import type { CurrentSite } from '@wegoTypes/currentSite';

const initialState: CurrentSite = getSiteConfigByHostname(window.location.hostname);

export default function (state: CurrentSite = initialState): CurrentSite {
  return state;
}
